import { createSlice } from "@reduxjs/toolkit";
import { InitialState } from "../interfaces/pricing.interfaces";

const initialState: InitialState = {
  isLoading: false,
  data: {
    states: 10,
    regions: 10,
    hospitalSystems: 10,
    hospitals: 10,
  },
};

const saveRegionsHospitalsLimit = createSlice({
  name: "Save the selection limit of the regions and hospitals dropdown",
  initialState,
  reducers: {
    saveRegionHospitalLimit(state, action) {
      state.data = action.payload;
    },
  },
});

export const { saveRegionHospitalLimit } = saveRegionsHospitalsLimit.actions;
export default saveRegionsHospitalsLimit.reducer;
